import { isPlannerView, type PlannerView } from '@/components/loop-planner/common/lib/plannerViews';

const storageKey = (scenarioId: number) => `planner.lastView.${scenarioId}`;

export const getLastViewedScenarioView = (scenarioId: number): PlannerView | null => {
  try {
    const raw = localStorage.getItem(storageKey(scenarioId));
    if (!raw) return null;
    return isPlannerView(raw) ? raw : null;
  } catch {
    return null;
  }
};

export const setLastViewedScenarioView = (scenarioId: number, view: PlannerView): void => {
  try {
    localStorage.setItem(storageKey(scenarioId), view);
  } catch {
    /* localStorage unavailable (quota, privacy mode) — ignore */
  }
};

export const clearLastViewedScenarioView = (scenarioId: number): void => {
  try {
    localStorage.removeItem(storageKey(scenarioId));
  } catch {
    /* localStorage unavailable — ignore */
  }
};
